import {createListenerMiddleware, isAnyOf} from '@reduxjs/toolkit';
import appAuthSlice from '../Slices/AppSlice/auth.slice';
import {contentAccessService} from '@src/Services/ContentAccess/ContentAccessService';
import {traceApi} from '@src/Api/TraceApi/traceApi';

/**
 * Middleware Redux pour gérer les effets de bord de la fermeture de modal d'authentification
 * 
 * Écoute l'action closeAuthModal et les succès d'authentification pour fermer automatiquement la modal
 */
export const authModalMiddleware = createListenerMiddleware();

// Écouter l'action closeAuthModal (fermeture manuelle)
authModalMiddleware.startListening({
  actionCreator: appAuthSlice.actions.closeAuthModal,
  effect: async (action, listenerApi) => {
    console.log('🎭 [AuthModalMiddleware] Handling manual closeAuthModal');
    
    try {
      // Synchroniser avec le ContentAccessService
      const currentState = contentAccessService.getCurrentState();
      if (currentState.showAuthModal) {
        console.log('🎯 [AuthModalMiddleware] Closing ContentAccessService auth modal');
        contentAccessService.actions.closeAuthModal();
      }
      
      console.log('✅ [AuthModalMiddleware] Auth modal closed successfully');
    } catch (error) {
      console.error('❌ [AuthModalMiddleware] Error closing auth modal:', error);
    }
  },
});

// 🆕 Écouter les succès d'authentification pour fermer automatiquement la modal
authModalMiddleware.startListening({
  matcher: isAnyOf(
    traceApi.endpoints.getMemberByUsername.matchFulfilled,
    // Ajouter d'autres endpoints d'auth success si nécessaire
  ),
  effect: async (action, listenerApi) => {
    const state = listenerApi.getState() as any;
    const isModalOpen = state.appAuth?.openAuthenticationModal?.open;
    
    if (isModalOpen && action.payload) {
      console.log('🎉 [AuthModalMiddleware] Authentication success detected, closing modal');
      
      // Dispatcher l'action de fermeture
      listenerApi.dispatch(appAuthSlice.actions.closeAuthModal());
    }
  },
});

export default authModalMiddleware; 